import { useCallback, useState } from 'react';

/**
 * O tema da interface: claro (fundo areia) ou escuro (preto).
 *
 * Quem decide o visual é o atributo `data-theme` no <html>, lido por
 * `styles/tokens.css`. A escolha é guardada no navegador — é preferência
 * de quem olha a tela, não dado da arena, então não vai para a API.
 *
 * O `index.html` aplica a escolha salva num script síncrono antes da
 * primeira pintura (para não piscar claro no escuro). A chave abaixo
 * precisa ser a mesma dele.
 */

export type Tema = 'light' | 'dark';

const CHAVE = 'sand-sports:tema';

/** O tema que está valendo agora, lido do próprio <html>. */
export function temaAtual(): Tema {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

export function aplicarTema(tema: Tema): void {
  document.documentElement.setAttribute('data-theme', tema);
  try {
    localStorage.setItem(CHAVE, tema);
  } catch {
    // Sem armazenamento (aba anônima, política do navegador): o tema vale
    // até recarregar, e isso é aceitável.
  }
}

export function useTema(): readonly [Tema, (tema: Tema) => void] {
  const [tema, setTema] = useState<Tema>(temaAtual);
  const definir = useCallback((novo: Tema) => {
    aplicarTema(novo);
    setTema(novo);
  }, []);
  return [tema, definir] as const;
}
